import styled, { css } from "styled-components";

const blurredBorderColor = "#d2d1d1";
const arrowDefaultBorderColor = "rgba(0, 0, 0, 0.1)";

const getBg = (props) =>
  props.blurred
    ? props.showOnHover
      ? "rgba(255,255,255,0.2)"
      : "rgba(255,255,255,0.8)"
    : "#ffffff";
const getArrowBg = (props) =>
  props.blurred
    ? props.showOnHover
      ? "rgba(255,255,255,0.3)"
      : "rgba(255,255,255,0.8)"
    : "#ffffff";
const getBackdrop = (props) => (props.blurred ? "blur(10px)" : "none");

const getArrowBorderBefore = (props) =>
  props.blurred
    ? `6px solid ${blurredBorderColor}`
    : `7px solid ${arrowDefaultBorderColor}`;

const getArrowBorderAfter = (props) =>
  props.blurred
    ? `6px solid ${blurredBorderColor}1a`
    : `6px solid ${arrowDefaultBorderColor}`;

const arrowStyles = {
  top: css`
    &:before {
      bottom: -7px;
      left: ${(props) => `calc(${props.arrowOffset}px)`};
      transform: translateX(-50%);
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: ${(props) => getArrowBorderBefore(props)};
      filter: ${(props) =>
        props.blurred ? "none" : "drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1))"};
    }
    &:after {
      bottom: -6px;
      left: ${(props) => `calc(${props.arrowOffset}px)`};
      transform: translateX(-50%);
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid ${(props) => getArrowBg(props)};
      filter: ${(props) =>
        props.blurred ? "none" : "drop-shadow(0 2px 1px rgba(0, 0, 0, 0.1))"};
    }
  `,
  bottom: css`
    &:before {
      top: -7px;
      left: ${(props) => `calc(${props.arrowOffset}px)`};
      transform: translateX(-50%);
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: ${(props) => getArrowBorderBefore(props)};
      filter: ${(props) =>
        props.blurred ? "none" : "drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.1))"};
    }
    &:after {
      top: -6px;
      left: ${(props) => `calc(${props.arrowOffset}px)`};
      transform: translateX(-50%);
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid ${(props) => getArrowBg(props)};
      filter: ${(props) =>
        props.blurred ? "none" : "drop-shadow(0 -2px 1px rgba(0, 0, 0, 0.1))"};
    }
  `,
  left: css`
    &:before {
      right: -7px;
      top: ${(props) => `calc(${props.arrowOffset}px)`};
      transform: translateY(-50%);
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      border-left: ${(props) => getArrowBorderBefore(props)};
      filter: ${(props) =>
        props.blurred ? "none" : "drop-shadow(2px 0 2px rgba(0, 0, 0, 0.1))"};
    }
    &:after {
      right: -6px;
      top: ${(props) => `calc(${props.arrowOffset}px)`};
      transform: translateY(-50%);
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 6px solid ${(props) => getArrowBg(props)};
      filter: ${(props) =>
        props.blurred ? "none" : "drop-shadow(2px 0 1px rgba(0, 0, 0, 0.1))"};
    }
  `,
  right: css`
    &:before {
      left: -7px;
      top: ${(props) => `calc(${props.arrowOffset}px)`};
      transform: translateY(-50%);
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      border-right: ${(props) => getArrowBorderBefore(props)};
      filter: ${(props) =>
        props.blurred ? "none" : "drop-shadow(-2px 0 1px rgba(0, 0, 0, 0.1))"};
    }
    &:after {
      left: -6px;
      top: ${(props) => `calc(${props.arrowOffset}px)`};
      transform: translateY(-50%);
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 6px solid ${(props) => getArrowBg(props)};
      filter: ${(props) =>
        props.blurred ? "none" : "drop-shadow(-2px 0 1px rgba(0, 0, 0, 0.1))"};
    }
  `,
};

const getArrowPlacementStyles = (props) => {
  const placementMap = {
    top: css`
      .arrow {
        position: absolute;
        left: ${(props) => `calc(${props.arrowOffset}px)`};
        top: 100%;
        transform: translateX(-50%);
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: ${(props) => `6px solid ${getArrowBg(props)}`};
        backdrop-filter: ${getBackdrop(props)};
        border-bottom: none;

        &:before {
          content: "";
          position: absolute;
          left: -0.1rem;
          top: -0.18rem;
          width: 9px;
          height: 1px;
          background: #d2d1d1;
          transform: rotate(-45deg);
        }

        &:after {
          content: "";
          position: absolute;
          left: -0.48rem;
          top: -0.18rem;
          width: 9px;
          height: 1px;
          background: #d2d1d1;
          transform: rotate(45deg);
        }
      }
    `,
    bottom: css`
      .arrow {
        position: absolute;
        left: ${(props) => `calc(${props.arrowOffset}px)`};
        top: -6px;
        transform: translateX(-50%);
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: ${(props) => `6px solid ${getArrowBg(props)}`};
        backdrop-filter: ${getBackdrop(props)};
        border-top: none;

        &:before {
          content: "";
          position: absolute;
          left: -0.48rem;
          top: 0.14rem;
          width: 9px;
          height: 1px;
          background: #d2d1d1;
          transform: rotate(-45deg);
        }

        &:after {
          content: "";
          position: absolute;
          left: -0.11rem;
          top: 0.18em;
          width: 9px;
          height: 1px;
          background: #d2d1d1;
          transform: rotate(45deg);
        }
      }
    `,
    left: css`
      .arrow {
        position: absolute;
        right: -6px;
        left: auto;
        top: ${(props) => `calc(${props.arrowOffset}px)`};
        transform: translateY(-50%);
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: ${(props) => `6px solid ${getArrowBg(props)}`};
        backdrop-filter: ${getBackdrop(props)};
        border-right: none;

        &:before {
          content: "";
          position: absolute;
          top: -0.21rem;
          left: -7px;
          width: 9px;
          height: 1px;
          background: #d2d1d1;
          transform: rotate(45deg);
        }

        &:after {
          content: "";
          position: absolute;
          top: 0.2em;
          left: -7px;
          width: 9px;
          height: 1px;
          background: #d2d1d1;
          transform: rotate(-45deg);
        }
      }
    `,
    right: css`
      .arrow {
        position: absolute;
        top: ${(props) => `calc(${props.arrowOffset}px)`};
        left: -6px;
        transform: translateY(-50%);
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: ${(props) => `6px solid ${getArrowBg(props)}`};
        backdrop-filter: ${getBackdrop(props)};

        &:before {
          content: "";
          position: absolute;
          top: -0.21rem;
          right: -0.43rem;
          width: 9px;
          height: 1px;
          background: #d2d1d1;
          transform: rotate(-45deg);
        }

        &:after {
          content: "";
          position: absolute;
          top: 0.17rem;
          right: -7px;
          width: 9px;
          height: 1px;
          background: #d2d1d1;
          transform: rotate(45deg);
        }
      }
    `,
  };
  const placementStyles = placementMap[props.placement] || placementMap.top;

  return placementStyles;
};

export const TooltipContainer = styled.div`
  position: fixed;
  padding: ${(props) => (props.blurred ? "8px" : "4px 8px")};
  font-size: ${(props) => (props.blurred ? "12px" : "10px")};
  background: ${(props) => getBg(props)};
  color: #333;
  border-radius: 4px;
  z-index: 15;
  min-width: 10px;
  max-width: 250px;
  word-wrap: break-word;
  pointer-events: none;
  line-height: 16px;
  box-shadow: ${(props) =>
    props.blurred ? "none" : "0 0 4px 2px rgba(0, 0, 0, 0.1)"};
  animation: fadeIn 0.3s ease-in-out;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? "all" : "none")};
  backdrop-filter: ${(props) => getBackdrop(props)};
  border: ${(props) =>
    props.blurred ? `1px solid ${blurredBorderColor}` : "none"};

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  &:before,
  &:after {
    content: "";
    position: absolute;
    z-index: -1;
  }
  ${(props) => getArrowPlacementStyles(props)}/* ${(props) =>
    arrowStyles[props.placement]} */
`;

export const TriggerWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "inherit")};

  ${(props) =>
    props.absolute &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `}
`;
